import { useConfig as hook } from '@eika-infrastruktur/config-provider';

const defaultTexts = {
    cardHeader: 'Har du vurdert å spare i fond til barnet ditt?',
    sparePerMndText: 'Månedlig sparing:',
    antallAarText: 'Barnets alder:',
    aarSuffix: 'år',
    aarPluralSuffix: 'år',
    resultatHeader: 'Forventet oppspart beløp når barnet er 18 år',
    resultatHeaderOverAtten: 'Nå har poden blitt voksen. På tide å spare til deg selv?',
    forventetTotalBelop: 'Forventet oppspart beløp:',
    dittInnskudd: 'Ditt totale innskudd:',
    smartsparText: 'Med vår Smartspar-app har det blitt enklere å spare i fond.',
    infoModalLabel: 'Hvordan beregnes verdiøkningen?',
    infoModalHeader: 'Hvordan beregnes forventet verdiøkning?',
    infoModalText1: 'Kalkulatoren forutsetter:',
    infoModalText2: '- Sparing i aksjefond med en avkastningsforventning på {$fondsRenteProsent}% per år.',
    infoModalText3: '- Beløpene er fratrukket en årlig inflasjon på 2%',
    infoModalText4:
        'Eksempelet har ikke hensyntatt eventuell skatt som vil kunne påhvile produktet og/eller kunden. Den skattemessige virkningen avhenger av den enkelte kundes individuelle situasjon og kan komme til å endre seg.',
    infoModalText5:
        'Forventet avkastning er ingen garanti for fremtidig avkastning. Fremtidig avkastning vil blant annet avhenge av markedsutviklingen, forvalterens dyktighet, fondets risikoprofil og tegnings- og forvaltningshonorar. Avkastningen kan bli negativ som følge av kurstap.',
    buttonText: 'Kom i gang',
    incrementValueText: 'oppskaler verdi',
    decrementValueText: 'nedskaler verdi'
};

const defaultNumbers = {
    barnetsAlderAarDefault: 6,
    sparingPerMndDefault: 1000,
    fondsRenteProsent: 5.75,
    inflasjonProsent: 2
};

interface Link {
    target?: string;
    text?: string;
    url: string;
}

interface Config {
    links: {
        redirectURL?: Link;
    };
    texts: typeof defaultTexts;
    numbers: typeof defaultNumbers;
}

export const defaultConfig: Config = {
    links: {
        redirectURL: {
            url: 'https://eika.no/smartspar'
        }
    },
    texts: defaultTexts,
    numbers: defaultNumbers
};

export const useConfig = () => hook<typeof defaultConfig>();
